import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { SelectCartItems } from 'projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-cart/store/cart.selectors';

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuard {
  constructor(
    private router: Router,
    private _store: Store
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._store.select(SelectCartItems).pipe(
      take(1),
      map((cartItems) => {
        const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
        if (totalQuantity > 0) {
          return true;
        } else {
          this.router.navigateByUrl('en/settings/cart');
          return false;
        }
      })
    );
  }
}
